import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { create, windowScheduler } from '@yornaath/batshit';

import { Collections } from '@graylog/enterprise-api';

const entityCollectionStatus = create({
  fetcher: (entityGRNs: Array<string>) => Collections.getStatuses({ entity_grns: entityGRNs }),
  resolver: (result) => result,
  scheduler: windowScheduler(10),
});

const useEntityCollectionStatus = (
  entityGRN: string,
  id: string,
): {
  data: Array<{ id: string; title: string }>;
  refetch: () => void;
  isFetching: boolean;
  isError: boolean;
} => {
  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: ['collections', id, 'status'],
    queryFn: async () => {
      const result = await entityCollectionStatus.fetch(entityGRN);

      return result?.[id];
    },
    placeholderData: keepPreviousData,
  });

  return {
    data,
    refetch,
    isFetching,
    isError,
  };
};

export default useEntityCollectionStatus;
